"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var ToolBarYearMonthFilter = /** @class */ (function (_super) {
    __extends(ToolBarYearMonthFilter, _super);
    function ToolBarYearMonthFilter(props) {
        return _super.call(this, props) || this;
    }
    ToolBarYearMonthFilter.prototype.onCheckBoxChecked = function (checked) {
        if (this.props.onDateChanged) {
            this.props.onDateChanged(checked, 0, 0, "checkbox");
        }
    };
    ToolBarYearMonthFilter.prototype.getSelectYearItems = function () {
        var _ret = [];
        for (var i = 0; i < this.props.availYears.length; i++) {
            _ret.push(React.createElement(antd_1.Select.Option, { key: "" + i, value: "" + this.props.availYears[i].key }, this.props.availYears[i].value));
        }
        return _ret;
    };
    ToolBarYearMonthFilter.prototype.getSelectMonthItems = function () {
        var _ret = [];
        for (var i = 0; i < this.props.availMonth.length; i++) {
            _ret.push(React.createElement(antd_1.Select.Option, { key: "" + i, value: "" + this.props.availMonth[i].key }, this.props.availMonth[i].value));
        }
        return _ret;
    };
    ToolBarYearMonthFilter.prototype.onYearValueChange = function (value, option) {
        if (this.props.onDateChanged) {
            this.props.onDateChanged(false, parseInt(value.key), 0, "year");
        }
    };
    ToolBarYearMonthFilter.prototype.onMonthValueChange = function (value, option) {
        if (this.props.onDateChanged) {
            this.props.onDateChanged(false, 0, parseInt(value.key), "month");
        }
    };
    ToolBarYearMonthFilter.prototype.getYearText = function (key) {
        for (var i = 0; i < this.props.availYears.length; i++) {
            if (this.props.availYears[i].key === key) {
                return this.props.availYears[i].value;
            }
        }
        return "";
    };
    ToolBarYearMonthFilter.prototype.getYearValue = function () {
        if (this.props.selectedYear === 0) {
            return undefined;
        }
        else {
            return {
                key: this.props.selectedYear.toString(),
                label: this.getYearText(this.props.selectedYear)
            };
        }
    };
    ToolBarYearMonthFilter.prototype.getMonthText = function (key) {
        for (var i = 0; i < this.props.availMonth.length; i++) {
            if (this.props.availMonth[i].key === key) {
                return this.props.availMonth[i].value;
            }
        }
        return "";
    };
    ToolBarYearMonthFilter.prototype.getMonthValue = function () {
        if (this.props.selectedMonth === 0) {
            return undefined;
        }
        else {
            return {
                key: this.props.selectedMonth.toString(),
                label: this.getMonthText(this.props.selectedMonth)
            };
        }
    };
    ToolBarYearMonthFilter.prototype.render = function () {
        return (React.createElement("div", { style: {
                display: "flex",
                width: "350px",
                flexWrap: "nowrap",
                justifyContent: "flex-start",
                alignItems: "center"
            } },
            React.createElement("div", { style: { marginLeft: "5px", marginRight: "5px", whiteSpace: "nowrap" } }, this.props.captions.checkbox),
            React.createElement(antd_1.Switch, { checked: this.props.allDates, onChange: this.onCheckBoxChecked.bind(this) }),
            React.createElement(antd_1.Select, { style: { width: "100px", marginLeft: "5px", marginRight: "2px" }, showSearch: true, disabled: this.props.allDates, placeholder: this.props.captions.placeholderYear, optionFilterProp: "children", filterOption: function (input, option) {
                    return option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0;
                }, onChange: this.onYearValueChange.bind(this), labelInValue: true, value: this.getYearValue() }, this.getSelectYearItems()),
            React.createElement(antd_1.Select, { style: { width: "100px", marginLeft: "2px", marginRight: "5px" }, showSearch: true, disabled: this.props.allDates, placeholder: this.props.captions.placeholderMonth, optionFilterProp: "children", filterOption: function (input, option) {
                    return option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0;
                }, onChange: this.onMonthValueChange.bind(this), labelInValue: true, value: this.getMonthValue() }, this.getSelectMonthItems())));
    };
    return ToolBarYearMonthFilter;
}(React.Component));
exports.default = ToolBarYearMonthFilter;



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/toolbars/ToolBarYearMonthFilter.tsx
// module id = 2337
// module chunks = 0